import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import Button from 'components/Button';
import {RadioChoice, CheckboxChoice} from './Choice';
import PollActions from './PollActions';
import styles from './PollAsk.css?module';

const POLL_TYPES = {
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
};

class PollAsk extends React.Component {
  state = {
    selectedIndexes: new Set(),
  };

  toggleIndex(index) {
    const selectedIndexes = new Set(this.state.selectedIndexes);

    if (selectedIndexes.has(index)) {
      selectedIndexes.delete(index);
    } else {
      selectedIndexes.add(index);
    }

    this.setState({selectedIndexes});
  }

  selectIndex(index) {
    this.setState({selectedIndexes: new Set([index])});
  }

  handleChoiceClick(index) {
    const {poll} = this.props;

    if (poll.type === POLL_TYPES.CHECKBOX) {
      this.toggleIndex(index);
    } else {
      this.selectIndex(index);
    }
  }

  handleVoteClick = () => {
    const {selectedIndexes} = this.state;

    if (selectedIndexes.size > 0) {
      this.props.onVote([...this.state.selectedIndexes]);
    }
  };

  render() {
    const {poll, onShowResults, canShowResults} = this.props;
    const {selectedIndexes} = this.state;

    const Choice =
      poll.type === POLL_TYPES.CHECKBOX ? CheckboxChoice : RadioChoice;

    const choices = poll.answers.map((answer, index) => (
      <Choice
        key={index}
        isSelected={selectedIndexes.has(index)}
        onClick={this.handleChoiceClick.bind(this, index)}
      >
        {answer}
      </Choice>
    ));

    return (
      <div>
        <div className={styles.choices}>{choices}</div>
        <PollActions>
          {canShowResults ? (
            <Button
              className={[styles.button, styles.showResults]}
              onClick={onShowResults}
              type={Button.TYPES.ALT}
              quiet={true}
            >
              <FormattedMessage
                id="PollAsk__ShowResults"
                description="Label for button to show results on a poll card"
                defaultMessage="See Results"
              />
            </Button>
          ) : null}
          <Button
            className={styles.button}
            onClick={this.handleVoteClick}
            disabled={selectedIndexes.size === 0}
          >
            <FormattedMessage
              id="PollAsk__Vote"
              description="Label for button to vote on a poll card"
              defaultMessage="Vote"
            />
          </Button>
        </PollActions>
      </div>
    );
  }
}

PollAsk.propTypes = {
  poll: PropTypes.object.isRequired,
  onVote: PropTypes.func.isRequired,
};

export default PollAsk;
